/**
 * Classe abstrata usada para enumerar os tipos de colorações que podem ser feitas no mapa.
 * 
 */
export abstract class ColorType {
    static CONTINUOUS = 1;
    static DISCRETE = 2;
    static CONSTANT = 3;
}